'use client';

import { useProductSearchBox } from '@dealerportal/react-helpers';
import { lazy, Suspense } from 'react';
import { ProductSearchBoxSkeleteon } from './skeletons/ProductSearchBoxSkeleton';

type ProductSearchBoxRendererProps = {
  isMobileDevice: boolean;
};

// The lazy component must be created once, at module scope. Creating it during
// render produces a new component type on every render, which makes React
// unmount and remount the dialog: the open <dialog> is replaced by a fresh
// closed one that is immediately re-opened on mount, and clicks on links inside
// it are lost.
const ProductSearchBoxDialog = lazy(() => import('./ProductSearchBoxDialog'));

export const ProductSearchBoxDialogLoader = (
  props: ProductSearchBoxRendererProps
) => {
  const ctx = useProductSearchBox();

  if (!ctx?.loaded) return null;

  return (
    <Suspense fallback={<ProductSearchBoxSkeleteon {...props} />}>
      <ProductSearchBoxDialog isMobileDevice={props.isMobileDevice} />
    </Suspense>
  );
};
